<template>
    <div class="row mx-0 col-12 px-0 mt-4">
        <h3 class="theme-primary col-12 px-0">{{title}}</h3>
        <div class="col-12 px-0 terms">
            <p class="font-weight-bold">{{pleaseNote}}</p>
            <p>{{acceptText}}</p>
            <ul class="fine-print">
                <li v-for="item in termsList" v-html="item"></li>
            </ul>
        </div>
        <div class="pl-3 ml-2 custom-control custom-checkbox">
            <input type="checkbox" class="theme-primary custom-control-input" id="agreeTerms" v-model="termsAgreed">
            <label for="agreeTerms" class="custom-control-label">{{userAccepts}}</label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConsentTerms",

        emits: ['update-terms-agreed'],

        props: {
            title: String,
            pleaseNote: String,
            acceptText: String,            
            termsList: Array,
            userAccepts: String
        },

        data: function() {
            return {
                termsAgreed: false
            }
        },

        watch: {
            termsAgreed: function(val) {
                this.$emit('update-terms-agreed', val);
            }
        }
    }
</script>